import { render, staticRenderFns } from "./confim-dialog.vue?vue&type=template&id=8d6e98e8&scoped=true&"
import script from "./confim-dialog.vue?vue&type=script&lang=js&"
export * from "./confim-dialog.vue?vue&type=script&lang=js&"
import style0 from "./confim-dialog.vue?vue&type=style&index=0&id=8d6e98e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6e98e8",
  null
  
)

export default component.exports